import { pumkinAPI } from "@api";
import { IConClose } from "@components";
import { PATH_HOME } from "@configs";
import { selectAuth, selectMerchant } from "@redux";
import { useNotify } from "@utils";
import { Input, Tabs } from "antd";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import useCache from "src/Store/useCache";
import styled from "styled-components";
import { BackIcon } from "../icon/TopSpender/BackIcon";

const { TabPane } = Tabs;

export const ComponentMyTools = () => {
    const userInfo = useSelector(selectAuth);
    const qrRef = useRef();
    const { success, error, warning } = useNotify();
    const history = useHistory();
    const [tab, setTab] = useState<string>("1");
    const [isShowPopup, setShowPopup] = useState<boolean>(false);
    const { themes } = useSelector(selectMerchant);
    const themeColor = themes?.themeColor;
    const [page, setPage] = useState<number>(1);
    const [toolsList, setToolsList] = useState<any[]>([]);
    const [dataClick, setDataClick] = useState<any>({});
    const [dataCondition, setDataCondition] = useState<any>({});
    const [dataNote, setDataNote] = useState<any>({});
    const [loading, setLoading] = useState<boolean>(false);
    const [isDetailTools, setDetailTools] = useState<boolean>(false);
    const [isDetailToolsSub, setDetailToolsSub] = useState<boolean>(false);
    const [selectedDetail, setSelectedDetail] = useState<"conditions" | "notes" | null>(null);
    const [searchValue, setSearchValue] = useState<string>("");

    useEffect(() => {
        getToolsList(tab === "1" ? "UNEXPIRED" : "EXPIRED");
    }, [tab, page]);

    function callback(items: any) {
        setToolsList([]);
        setSearchValue("");
        setPage(1);
        setTab(items);
    }

    const resetStates = () => {
        setDataClick({});
        setDataCondition({});
        setDataNote({});
        setDetailTools(false);
    };

    const getToolsList = async (group: string) => {
        try {
            useCache.setState({ isLoading: true });
            const getList = await pumkinAPI.getWarrantyList({
                status: "APPROVE",
                group: group,
                limit: 10,
                page: page,
                user_id: userInfo?.userInfo?._id,
            });
            if (getList.data) {
                setToolsList((prevData) => [
                    ...prevData,
                    ...(getList.data?.data ? getList.data?.data : []),
                ]);
            }
        } catch (err: any) {
            err.response?.data?.message ? error(err.response?.data?.message) : error(err.message);
        } finally {
            useCache.setState({ isLoading: false });
        }
    };

    const handleSearch = async (value: string) => {
        setSearchValue(value);
        console.log(value);
        await pumkinAPI
            .getWarrantyList({
                status: "APPROVE",
                group: tab === "1" ? "UNEXPIRED" : "EXPIRED",
                limit: 10,
                page: page,
                user_id: userInfo?.userInfo?._id,
                search: value,
            })
            .then((res) => {
                setToolsList(res.data?.data ? res.data?.data : []);
            })
            .catch((err) => {
                console.log("searchMyDevice", err);
            });
    };

    return (
        <StyledContainer color={themes?.themeColor!}>
            <div className="container">
                <div className="backIcon" onClick={() => history.push(PATH_HOME)}>
                    <BackIcon color={"#FFF"} />
                    <h2>รับประกันออนไลน์</h2>
                    <p> </p>
                </div>
                <div className="content">
                    <Tabs defaultActiveKey="1" activeKey={tab} onChange={callback}>
                        <TabPane
                            tab={
                                <span
                                    style={{
                                        color: tab === "1" ? themeColor : "#9B9B9B",
                                        fontSize: "13px",
                                    }}
                                >
                                    ยังอยู่ในการรับประกัน
                                </span>
                            }
                            key="1"
                            style={{ overflow: "auto" }}
                        >
                            <div className="wrapper-group-tools">
                                <div className="layout-search-tools">
                                    <span>
                                        <img src="../../images/ic-search-tools.svg" alt="" />
                                    </span>
                                    <Input
                                        placeholder="ค้นหาอุปการณ์..."
                                        value={searchValue}
                                        onChange={(e) => handleSearch(e.target.value)}
                                    />
                                </div>
                                {toolsList.map((tool: any, index: number) => (
                                    <div className="layout-box-tools" key={index}>
                                        <div className="img-box-tools">
                                            <img
                                                src={tool.product_image ? tool.product_image : ""}
                                                alt={tool.product_name || "-"}
                                            />
                                        </div>
                                        <div className="layout-details-tools">
                                            <div className="title-box-tools">
                                                {tool.product_name || "-"}
                                            </div>
                                            <div className="details-tools">
                                                {tool.product_model || "-"}
                                            </div>
                                            <div className="btn-link-tools">
                                                <div className="exp-tools">
                                                    {tool?.expireDuration === "infinity"
                                                        ? "กำลังตรวจสอบ"
                                                        : tool?.expireDuration === "expired"
                                                        ? "หมดเขตรับประกัน"
                                                        : "เหลืออีก " +
                                                          tool?.expireDuration +
                                                          " วัน"}
                                                </div>
                                                <StyledBtnDetailsTools
                                                    onClick={() => {
                                                        setDetailTools(true);
                                                        setDataClick(tool);
                                                    }}
                                                >
                                                    ดูรายละเอียด
                                                </StyledBtnDetailsTools>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </TabPane>
                        <TabPane
                            tab={
                                <span
                                    style={{
                                        color: tab === "2" ? themeColor : "#9B9B9B",
                                        fontSize: "13px",
                                    }}
                                >
                                    หมดเขตการรับประกัน
                                </span>
                            }
                            key="2"
                        >
                            <div className="wrapper-group-tools">
                                <div className="layout-search-tools">
                                    <span>
                                        <img src="../../images/ic-search-tools.svg" alt="" />
                                    </span>
                                    <Input
                                        placeholder="ค้นหาอุปการณ์..."
                                        value={searchValue}
                                        onChange={(e) => handleSearch(e.target.value)}
                                    />
                                </div>
                                {toolsList.map((tool: any, index: number) => (
                                    <div className="layout-box-tools active">
                                        <div className="img-box-tools">
                                            <img
                                                src={tool.product_image ? tool.product_image : ""}
                                                alt=""
                                            />
                                        </div>
                                        <div className="layout-details-tools">
                                            <div className="title-box-tools">
                                                {tool.product_name || "-"}
                                            </div>
                                            <div className="details-tools">
                                                {tool.product_model || "-"}
                                            </div>
                                            <div className="btn-link-tools">
                                                <div className="exp-tools expire">
                                                    หมดเขตการรับประกัน
                                                </div>
                                                <StyledBtnDetailsTools
                                                    onClick={() => {
                                                        setDetailTools(true);
                                                        setDataClick(tool);
                                                    }}
                                                >
                                                    ดูรายละเอียด
                                                </StyledBtnDetailsTools>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </TabPane>
                    </Tabs>
                </div>
            </div>
            {isDetailTools && (
                <StyledShowPopup themeColor={themes?.themeColor!}>
                    <div className="page-wrapper">
                        <div className="close" onClick={resetStates}>
                            <IConClose width={16} />
                        </div>
                        <div className="content-layout">
                            <div className="img-detail-tools">
                                <img src={dataClick?.product_image || " "} alt="" />
                            </div>
                            <div className="title-details-tools">
                                <h2>{dataClick?.product_name || "-"}</h2>
                            </div>
                            <TableContainer>
                                <Table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <FaMapMarkerAlt color="#f56c6c" /> หน้าร้าน
                                            </td>
                                            <td className="text-center">
                                                {dataClick?.store || "-"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>รหัสสินค้า</td>
                                            <td className="text-center">
                                                {dataClick?.product_code || "-"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>รุ่น</td>
                                            <td className="text-center">
                                                {dataClick?.product_model || "-"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>เลขซีเรียล</td>
                                            <td className="text-center">
                                                {dataClick?.serial_number || "-"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>วันที่ซื้อสินค้า</td>
                                            <td className="text-center">
                                                {dataClick?.purchase_date && <FaCalendarAlt />}
                                                {dataClick?.purchase_date
                                                    ? format(
                                                          new Date(dataClick?.purchase_date),
                                                          "DD/MM/YYYY"
                                                      )
                                                    : "-"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>วันหมดอายุ</td>
                                            <td className="text-center">
                                                {dataClick?.expire_warranty_date && (
                                                    <FaCalendarAlt />
                                                )}
                                                {dataClick?.expire_warranty_date
                                                    ? format(
                                                          new Date(dataClick?.expire_warranty_date),
                                                          "DD/MM/YYYY"
                                                      )
                                                    : " "}{" "}
                                                {dataClick?.expire_warranty_date && (
                                                    <WarrantyRemaining>
                                                        {/* cal expired date */}
                                                        {dataClick?.expireDuration === "infinity"
                                                            ? "กำลังตรวจสอบ"
                                                            : dataClick?.expireDuration ===
                                                              "expired"
                                                            ? "หมดเขตรับประกัน"
                                                            : "เหลืออีก " +
                                                              dataClick?.expireDuration +
                                                              " วัน"}
                                                    </WarrantyRemaining>
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>ระยะเวลารับประกัน</td>
                                            <td className="text-center">
                                                {dataClick?.warranty_duration_month
                                                    ? dataClick?.warranty_duration_month + " เดือน"
                                                    : "-"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>เงื่อนไขรับประกัน</td>
                                            <td>
                                                {Array.isArray(dataClick?.condition) &&
                                                dataClick?.condition.length > 0 ? (
                                                    <ul>
                                                        {dataClick?.condition.map(
                                                            (item: string, index: number) => (
                                                                <li key={index}>{item}</li>
                                                            )
                                                        )}
                                                    </ul>
                                                ) : (
                                                    <div className="text-center">-</div>
                                                )}

                                                {Array.isArray(dataClick?.condition) &&
                                                    dataClick?.condition.length > 0 && (
                                                        <div
                                                            className="readmore"
                                                            onClick={() => {
                                                                setSelectedDetail("conditions");
                                                                setDataCondition(
                                                                    dataClick?.condition
                                                                );
                                                            }}
                                                        >
                                                            อ่านต่อ
                                                        </div>
                                                    )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>หมายเหตุรับประกัน</td>
                                            <td>
                                                {Array.isArray(dataClick?.remark) &&
                                                dataClick?.remark.length > 0 ? (
                                                    dataClick?.remark.map(
                                                        (item: string, index: number) => (
                                                            <Note key={index}>⚠️ {item}</Note>
                                                        )
                                                    )
                                                ) : (
                                                    <div className="text-center">-</div>
                                                )}
                                                {Array.isArray(dataClick?.remark) &&
                                                    dataClick?.remark.length > 0 && (
                                                        <div
                                                            className="readmore"
                                                            onClick={() => {
                                                                setSelectedDetail("notes");
                                                                setDataNote(dataClick?.remark);
                                                            }}
                                                        >
                                                            อ่านต่อ
                                                        </div>
                                                    )}
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </StyledShowPopup>
            )}

            {selectedDetail && (
                <StyledShowPopup themeColor={themes?.themeColor!}>
                    <div className="page-wrapper">
                        <div
                            className="back"
                            onClick={() => {
                                setSelectedDetail(null);
                                setDataCondition({});
                                setDataNote({});
                            }}
                        >
                            <BackIcon color={"#000"} />
                        </div>
                        {/* <div className="close" onClick={resetStates}>
                            <IConClose width={16} />
                        </div> */}
                        <div className="content-layout">
                            {selectedDetail === "conditions" ? (
                                <>
                                    <h3>เงื่อนไขการรับประกัน</h3>
                                    <ul>
                                        {dataCondition.map((item: string, index: number) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>
                                </>
                            ) : (
                                <>
                                    <h3>หมายเหตุรับประกัน</h3>
                                    <ul>
                                        {dataNote.map((item: string, index: number) => (
                                            <li key={index}>⚠️ {item}</li>
                                        ))}
                                    </ul>
                                </>
                            )}
                        </div>
                    </div>
                </StyledShowPopup>
            )}
        </StyledContainer>
    );
};

const StyledShowPopup = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
    justify-content: end;
    transition: 2s !important;
    animation: opacity 0.5s !important;
    @keyframes opacity {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    .page-wrapper {
        position: relative;
        width: 100%;
        min-height: 55%;
        max-height: 90dvh;
        background-color: #fff;
        border-top-left-radius: 14px;
        border-top-right-radius: 14px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .close {
            position: absolute;
            right: 18px;
            top: 18px;
            z-index: 1;
        }
        .back {
            position: absolute;
            left: 18px;
            top: 18px;
            z-index: 1;
        }
    }
    .content-layout {
        height: auto;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #fff;
        /* padding-top: 24px;
        padding-bottom: 24px; */
        padding: 48px 24px;
        min-height: 60%;
        width: 100%;
        animation: bottomtotop 0.5s !important;
        position: relative;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        .edit-sub-text {
            font-size: 14px;
            line-height: 17px;
            text-align: center;
            color: #f2a808;
            margin-bottom: 12px;
        }
        .img-detail-tools {
            width: 140px;
            height: 140px;
            border-radius: 100%;
            overflow: hidden;
            text-align: center;
            margin: 0 auto;
            position: relative;
            margin-top: -90px;
            background-color: #fff;
            margin-bottom: 25px;
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }
        .title-details-tools {
            h2 {
                font-size: 18px;
                font-weight: 600;
                line-height: 21px;
                color: #000;
                margin-bottom: 16px;
                text-align: center;
            }
        }
    }
`;

const TableContainer = styled.div`
    width: 100%;
    max-width: 600px;
    margin: auto;
    border-radius: 12px;
    overflow: hidden;
    background: #fef7f5;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    .text-center {
        text-align: center;
    }
`;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    td,
    th {
        padding: 12px;
        border-bottom: 1px solid #eee;
    }

    td:first-child {
        width: 35%;
        text-align: center;
        border-right: 1px solid #eee;
    }
`;

const WarrantyRemaining = styled.span`
    color: #d9534f;
    background: #fdecea;
    padding: 4px 8px;
    border-radius: 8px;
    font-size: 12px;
`;

const Note = styled.div`
    font-size: 12px;
    color: #ff9800;
    display: flex;
    align-items: center;
    gap: 8px;
`;
const StyledBtnDetailsTools = styled.button`
    background-color: #231f20;
    color: #fff;
    padding: 6px 13px;
    border-radius: 8px;
    font-size: 11px;
    text-align: center;
    line-height: 14px;
`;
const StyledContainer = styled.div<{ color: string }>`
    height: 100dvh;
    background-color: ${(p) => p.color};

    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #ff0000 !important;
        font-weight: 500;
    }
    .ant-tabs-nav-wrap {
        .ant-tabs-ink-bar {
            position: absolute;
            background: ${(p) => p.color};
            pointer-events: none;
            width: 20px !important;
            height: 3px;
            bottom: 5px;
            left: 37px;
            border-radius: 4px;
        }
    }
    .ant-tabs-content {
        margin-top: 10px;
    }
    .container {
        .backIcon {
            display: flex;
            position: absolute;
            top: 20px;
            left: 20px;
            cursor: pointer;
            z-index: 1;
            align-items: center;
            justify-content: space-between;
            width: 80%;
        }
        h2 {
            color: #fff;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
        .ant-divider {
            background: #e1e1e1;
            width: 90%;
            min-width: 90%;
            margin: auto;
            margin: 22px auto 16px auto;
        }
    }
    .content {
        width: 100%;
        height: 90dvh;
        background-color: #fff;
        position: absolute;
        left: 0;
        bottom: 0;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        overflow-y: auto;
        padding: 9px 16px 0px 16px;
        display: flex;
        flex-direction: column;
        .ant-tabs {
            height: 100%;
            display: flex;
            flex-direction: column;
        }
        .ant-tabs-content-holder {
            flex: 1;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            padding-bottom: 20px;
        }
        .ant-tabs-content,
        .ant-tabs-tabpane {
            height: 100%;
        }
        .wrapper-group-tools {
            padding-bottom: 12px;
            .layout-search-tools {
                position: relative;
                margin-bottom: 15px;
                span {
                    position: absolute;
                    left: 12px;
                    top: 16px;
                    z-index: 1;
                    img {
                        width: 16px;
                        height: 16px;
                    }
                }
                input {
                    padding-left: 35px !important;
                }
            }
            .active {
                .img-box-tools {
                    opacity: 0.3;
                }
            }
            .layout-box-tools {
                padding: 15px 0 15px 150px;
                position: relative;
                margin-bottom: 15px;
                border-bottom: 1px solid #f0f0f0;
                .img-box-tools {
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 140px;
                    img {
                        width: 100%;
                        max-height: 90px;
                        object-fit: contain;
                    }
                }
                .btn-link-tools {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .exp-tools {
                        display: inline-block;
                        padding: 4px 10px;
                        background-color: #ffdbd8;
                        color: #eb4a3b;
                        border-radius: 16px;
                        font-size: 10px;
                        line-height: 13px;
                        height: 22px;
                    }
                    .exp-tools.expire {
                        background-color: #e0e0e0;
                        color: #525257;
                    }
                }
                .layout-details-tools {
                    .title-box-tools {
                        font-size: 14px;
                        line-height: 17px;
                        color: #000;
                        font-weight: 600;
                        margin-bottom: 6px;
                    }
                    .details-tools {
                        font-size: 11px;
                        line-height: 14px;
                        color: #9b9b9b;
                        margin-bottom: 8px;
                    }
                }
            }
        }
        .ant-tabs-nav {
            .ant-tabs-tab {
                padding: 0;
                margin: 0px 10px 10px 0px !important;
                width: 145px;
                height: 30px;
                span {
                    font-size: 16px;
                    font-weight: 600;
                }
            }
        }
        .contentRow {
            display: flex;
            flex-direction: column;
            gap: 6px;
            position: relative;
            overflow: auto;
            height: 70dvh;
            padding-bottom: 20px;
        }
    }
`;
